var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"output default-page-wrapper"},[_c('main-title-back',{attrs:{"title":"Выплата средств","href":"Balance"}}),(_vm.showOutputWithCard)?_c('balance-output-with-card'):_c('balance-output-without-card'),_c('BalanceOutputHistory',{staticClass:"output__history"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }